import { Tooltip } from "@mui/material";
import { isValidElement, type ReactElement, type ReactNode } from "react";

type Props = {
  title: string;
  children: ReactElement;
  placement?: "top" | "bottom" | "left" | "right";
};

export function LeadActionTooltip({
  title,
  children,
  placement = "top",
}: Props) {
  if (!title) return children;

  const disabled =
    isValidElement(children) &&
    Boolean((children.props as { disabled?: boolean }).disabled);

  const wrapped: ReactNode = disabled ? (
    <span style={{ display: "inline-flex", lineHeight: 0 }}>{children}</span>
  ) : (
    children
  );

  return (
    <Tooltip title={title} arrow placement={placement}>
      {isValidElement(wrapped) ? wrapped : <span>{wrapped}</span>}
    </Tooltip>
  );
}
